module.exports = __webpack_public_path__ + "img/nanning.814df362.png";